module.exports = __webpack_public_path__ + "static/media/externalBarn_17.fd65084c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_17.png
// module id = 1305
// module chunks = 3